import React, { useEffect, useState } from 'react';
import TaskConsole from '../TaskConsole';
import { useTaskStore, taskCounts } from '../../lib/task-store';

/**
 * State for the TaskConsole panel (registry id `taskConsole`): background work registered
 * through lib/worker-pool.js (`run(..., { label })`). The panel is open while there are
 * tasks and the user has not closed it; it reopens on the next running task.
 * Returns { open, setOpen, element } for MapView / DockLayout.
 */
export function useTaskConsole() {
  const { tasks, log } = useTaskStore();
  const counts = taskCounts(tasks);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (counts.running > 0) setDismissed(false);
  }, [counts.running]);

  const open = !dismissed && tasks.length > 0;
  const element = open
    ? <TaskConsole entries={log} tasks={counts} taskList={tasks} onClose={() => setDismissed(true)} />
    : null;
  return { open, setOpen: (v) => setDismissed(!v), element };
}

/** Standalone renderer kept for callers outside the dock layout. */
export default function TaskConsoleHost() {
  const { element } = useTaskConsole();
  return element;
}
